import SimpleProduct from "./SimpleProduct";
export default SimpleProduct;
